import { Component } from '@angular/core';

/**
 * Generated class for the ViewerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'viewer',
  templateUrl: 'viewer.html'
})
export class ViewerComponent {

  text: string;

  constructor() {
    console.log('Hello ViewerComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/viewer/viewer.ts